import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./user";
import appReducer from "./app";

export default configureStore({
  reducer: {
    appSystem: appReducer,
    users: userReducer,
  },
});
